import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { Page } from '@tracking';

import Header from './Header';
import HowSection from './HowSection';
import MediaKitSection from './MediaKitSection';
import WhoSection from './WhoSection';
import WhySection from './WhySection';

const PartnersContent = (): JSX.Element => {
  const { Track } = useEventTracking({
    page: Page.BrandPartnerships,
  });

  return (
    <Track>
      <main className="mx-auto max-w-[1060px]">
        <Header />
        <WhySection />
        <WhoSection />
        <HowSection />
        <MediaKitSection />
      </main>
    </Track>
  );
};

export default PartnersContent;
